import {
    BarChart,
    Bar,
    ResponsiveContainer,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Label,
} from "recharts";

import {
    Box,
    Text,
} from "@chakra-ui/react";

import Card from "./Card";

const CommissionTrendChart = ({
    milestones = [],
}) => {
    const monthOrder = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    const monthlyCommission =
        milestones.reduce(
            (
                acc,
                milestone
            ) => {
                if (
                    milestone.commission_status !==
                    "Paid"
                ) {
                    return acc;
                }

                const date =
                    new Date(
                        milestone.updated_at ||
                        milestone.created_at
                    );

                const month =
                    date.toLocaleDateString(
                        "en-US",
                        {
                            month:
                                "short",
                        }
                    );

                acc[month] =
                    (
                        acc[
                            month
                        ] || 0
                    ) +
                    Number(
                        milestone.commission_amount ||
                        0
                    );

                return acc;
            },
            {}
        );

    const data =
        monthOrder.map(
            (
                month
            ) => ({
                month,
                value:
                    monthlyCommission[
                        month
                    ] || 0,
            })
        );

    return (
        <Card>
            <Box mb={6}>
                <Text
                    fontSize="lg"
                    fontWeight="700"
                    color="#071D54"
                >
                    Commission Trend
                </Text>

                <Text
                    color="gray.500"
                    fontSize="sm"
                >
                    Monthly commission
                    payouts earned from
                    recruit milestones.
                </Text>
            </Box>

            <ResponsiveContainer
                width="100%"
                height={280}
            >
                <BarChart
                    data={data}
                    margin={{
                        top: 20,
                        right: 20,
                        left: 10,
                        bottom: 20,
                    }}
                >
                    <CartesianGrid
                        strokeDasharray="3 3"
                        vertical={false}
                        stroke="#E2E8F0"
                    />

                    <XAxis
                        dataKey="month"
                        tick={{
                            fontSize: 12,
                        }}
                    >
                        <Label
                            value="Month"
                            offset={-10}
                            position="insideBottom"
                        />
                    </XAxis>

                    <YAxis
                        tick={{
                            fontSize: 12,
                        }}
                        tickFormatter={(
                            value
                        ) =>
                            `P${value}`
                        }
                    >
                        <Label
                            value="Commission (P)"
                            angle={-90}
                            position="insideLeft"
                        />
                    </YAxis>

                    <Tooltip
                        formatter={(
                            value
                        ) => [
                            `P${Number(
                                value
                            ).toFixed(
                                2
                            )}`,
                            "Commission",
                        ]}
                    />

                    <Bar
                        dataKey="value"
                        fill="#2453FF"
                        radius={[
                            6,
                            6,
                            0,
                            0,
                        ]}
                    />
                </BarChart>
            </ResponsiveContainer>
        </Card>
    );
};

export default CommissionTrendChart;